import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { ClosuresDetailsDTO } from "@/model/data.model";
import {
  GetClosureResults,
  SearchParams,
  ClosureListItem
} from "@/model/component.model";
import store from "../vuex/store";

/// Facade to API Closures service
/// Implements a cache to allow local searching
export class ClosureService {
  static getClosures(
    customerMbeId: string,
    search: SearchParams = { search: "", page: 0, pageSize: 25 } as SearchParams
  ): Promise<GetClosureResults> {
    const config: AxiosRequestConfig = {
      method: "GET",
      url: store.getters.BASE_API_URL + "/shipments/online-mbe/closure",
      params: {
        search: search.search,
        page: search.page,
        size: search.pageSize,
        sort: "onlineMBEClosureId,desc",
        customerId: customerMbeId
      }
    };

    return axios.request(config).then((res: AxiosResponse) => {
      const closures = res.data.content as ClosuresDetailsDTO[];
      const searchParams = {
        search: search.search,
        orderField: search.orderField,
        orderDirection: search.orderDirection,
        totalElements: res.data.totalElements,
        totalPages: res.data.totalPages,
        numberOfElements: res.data.numberOfElements,
        page: res.data.number,
        pageSize: res.data.size
      } as SearchParams;

      return { closures, searchParams } as GetClosureResults;
    });
  }

  static printManifests(
    closures: ClosureListItem[],
    courierId = 0,
    courierName = "MBE",
    action = "PRINT_DETAILED_MANIFEST"
  ): Promise<string[]> {
    const shipmentsIdArray: string[] = [];

    closures.forEach(closure => {
      closure.shipmentIdSet.forEach(set => {
        shipmentsIdArray.push(set);
      });
    });

    const manifestData = {
      shipmentIdList: shipmentsIdArray,
      action: action,
      manifestType: "ONLINE",
      courierId: courierId,
      courierName: courierId === 99 ? "Other" : courierName,
      generateNewManifest: true
    };

    const config: AxiosRequestConfig = {
      method: "POST",
      url: store.getters.BASE_API_URL + "/shipments/manifest",
      data: manifestData
    };
    return axios
      .request(config)
      .then(res => {
        return res.data.base64ContentDocument;
      })
      .catch(err => {
        return Promise.reject(err);
      });
  }
}
